<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="7">
        <HMIHistory type="prediction" />
      </v-col>
      <v-col cols="5">
        <v-card class="py-4 px-8">
          <v-row>
            <v-col cols="4">
              <PredictionInterval
                :interval="interval"
                :loading="calculationLoading"
                @select="handleIntervalSelect"
                @submit="submitPrediction"
              />
            </v-col>
            <v-col cols="8">
              <PredictionResults />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12">
        <HMIMap />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HMIMap from "@/components/hmi/HMIMap";
import PredictionInterval from "./fragments/prediction.interval.vue";
import PredictionResults from "./fragments/prediction.result.vue";
import HMIHistory from "@/components/hmi/HMIHistory";
import { CALCULATE_PREDICTION } from "@/core/services/store/modules/hmi/hmi.module";
import { SET_ALERT } from "@/core/services/store/modules/alert/alert.module";

export default {
  name: "Prediction",

  data() {
    return {
      interval: 3,
      calculationLoading: false,
    };
  },

  methods: {
    handleIntervalSelect(interval) {
      this.interval = interval;
    },
    async submitPrediction() {
      this.calculationLoading = true;
      await this.$store
        .dispatch(CALCULATE_PREDICTION, this.interval)
        .catch((error) => {
          this.$store.commit(SET_ALERT, {
            text: error.message,
            isError: true,
          });
        });
      this.calculationLoading = false;
    },
  },

  components: {
    HMIMap,
    HMIHistory,
    PredictionInterval,
    PredictionResults,
  },
};
</script>

<style></style>
